import React from 'react';
import { Button } from 'react-bootstrap';
import styles from '../styles/WaitingScreen.module.scss';

interface WaitingScreenProps {
  document: {
    title: string;
  };
  currentSigner?: string;
  onRefresh: () => void;
}

export const WaitingScreen: React.FC<WaitingScreenProps> = ({ document, currentSigner, onRefresh }) => {
  return (
    <div className={styles.waitingContainer}>
      <div className={styles.waitingCard}>
        <div className={styles.waitingIcon}>
          <svg width="80" height="80" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="35" fill="none" stroke="#FFA726" strokeWidth="3" strokeDasharray="5 5">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 40 40"
                to="360 40 40"
                dur="20s"
                repeatCount="indefinite"
              />
            </circle>
            <text x="40" y="45" textAnchor="middle" fontSize="30" fill="#FFA726">
              ⏱
            </text>
          </svg>
        </div>

        <h1>Waiting for Your Turn</h1>

        <p className={styles.documentTitle}>{document.title}</p>

        <div className={styles.message}>
          <p>This document requires signatures in a specific order.</p>
          {currentSigner && (
            <p className={styles.currentSigner}>
              Currently waiting for: <strong>{currentSigner}</strong>
            </p>
          )}
          <p>You will be notified when it's your turn to sign.</p>
        </div>

        <div className={styles.actions}>
          <Button variant="secondary" onClick={onRefresh}>
            Check Status
          </Button>
        </div>

        <div className={styles.footer}>
          <p>This page will automatically refresh when it's your turn to sign.</p>
        </div>
      </div>
    </div>
  );
};
